import {
  Button,
  Modal,
  RadioGroup,
  RadioItem,
  Textarea,
  useToast,
} from '@driftt/dds'
import { tracking } from '@driftt/traffic-control'
import React, { useState } from 'react'

interface FeedbackModalProps {
  open: boolean
  onClose: () => void
}

const PMF_OPTIONS = [
  {
    value: 'very disappointed',
    label: 'Very disappointed',
  },
  {
    value: 'somewhat disappointed',
    label: 'Somewhat disappointed',
  },
  {
    value: 'not disappointed',
    label: 'Not disappointed',
  },
]

const FeedbackModal = ({ open, onClose }: FeedbackModalProps) => {
  const notify = useToast()
  const DEFAULT_PMF_VALUE = 'none'
  const [feedback, setFeedback] = useState<string | undefined>()
  const [pmf, setPmf] = useState<string>(DEFAULT_PMF_VALUE)
  const handleValueChange = (value: string) => {
    setPmf(value)
  }

  const handleClose = () => {
    setFeedback(undefined)
    setPmf(DEFAULT_PMF_VALUE)
    onClose()
  }

  const submitFeedback = () => {
    tracking.trackEvent('pb-collab-feedback', { feedback, pmf })
    notify({
      variant: 'success',
      message: 'Feedback submitted',
    })
    handleClose()
  }

  return (
    <Modal.Root open={open} onClose={handleClose}>
      <Modal.Dialog size="medium" variant="info">
        <Modal.Title title="Give Feedback" />
        <Modal.Content>
          <RadioGroup
            label="How would you feel if you could no longer use Content review mode?"
            value={pmf}
            onValueChange={handleValueChange}
          >
            {PMF_OPTIONS.map((option) => (
              <RadioItem value={option.value} label={option.label} />
            ))}
          </RadioGroup>
          <br />
          <Textarea
            optional
            size="full-width"
            label="How can we make building playbooks easier for you?"
            value={feedback}
            placeholder="It’d be great if I could..."
            onChange={(e) => setFeedback(e.target.value)}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            disabled={pmf === DEFAULT_PMF_VALUE}
            variant="primary"
            onClick={submitFeedback}
          >
            Submit
          </Button>
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}

export default FeedbackModal
